import React, { useRef, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { Edges } from '@react-three/drei';

const SMOOTHNESS = 5; // larger = snappier, smaller = more lag

export default function Cube({ sensorDataQueue }) {
  const meshRef = useRef();

  // debug logging
  useEffect(() => {
    console.log(
      '🔷 gyroX:', sensorDataQueue.gyroX,
      'gyroY:', sensorDataQueue.gyroY,
      'gyroZ:', sensorDataQueue.gyroZ
    );
  }, [sensorDataQueue.gyroX, sensorDataQueue.gyroY, sensorDataQueue.gyroZ]);

  useFrame((_, delta) => {
    if (!meshRef.current) return;
    const { gyroX = [], gyroY = [], gyroZ = [] } = sensorDataQueue;
    const i = gyroX.length - 1;
    if (i < 0) return;

    // Raw values in radians
    const targetRoll  = Number(gyroX[i]) || 0;
    const targetPitch = Number(gyroY[i]) || 0;
    const targetYaw   = Number(gyroZ[i]) || 0;

    // Compute a delta-based lerp factor (clamped 0–1)
    const t = THREE.MathUtils.clamp(SMOOTHNESS * delta, 0, 1);

    // Smoothly move each axis toward its target
    meshRef.current.rotation.x = THREE.MathUtils.lerp(
      meshRef.current.rotation.x,
      targetPitch,
      t
    );
    meshRef.current.rotation.y = THREE.MathUtils.lerp(
      meshRef.current.rotation.y,
      targetYaw,
      t
    );
    meshRef.current.rotation.z = THREE.MathUtils.lerp(
      meshRef.current.rotation.z,
      targetRoll,
      t
    );
  });

  return (
    <mesh ref={meshRef} scale={[3, 3, 3]}>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color="white" />
      <Edges width={0.02} color="black" />
    </mesh>
  );
}
